module.exports = __webpack_public_path__ + "assets/img/login.6dff6d66.png";